import {
  getV1CompaniesCompanyIdJobsTypeahead,
  Job_Read_Typeahead,
} from '@treadinc/horizon-api-spec';
import { FieldValues } from 'react-hook-form';

import AsyncAutocompleteField from '../v2/Autocomplete/AsyncAutocompleteField';
import { CommonAsyncAutocompleteFieldProps } from '../v2/Autocomplete/types';

type Props<T extends FieldValues> = CommonAsyncAutocompleteFieldProps<
  T,
  Job_Read_Typeahead,
  Job_Read_Typeahead,
  Record<string, unknown>
> & { companyId: string };

export default function AutocompleteJobsTypeahead<T extends FieldValues>({
  companyId,
  isDisabled,
  ...rest
}: Props<T>) {
  return (
    <AsyncAutocompleteField
      {...rest}
      isDisabled={companyId ? isDisabled : true}
      queryName="AutocompleteJobsTypeahead"
      fetchFn={{
        arguments: { path: { 'company-id': companyId } },
        request: getV1CompaniesCompanyIdJobsTypeahead,
      }}
      parseFn={(item: Job_Read_Typeahead) => ({
        _entity: item,
        label: item.job_id,
        value: item.job_id,
      })}
    />
  );
}
